<template>
  <div>
    <!-- Header portals and other content for desktop -->
    <portal to="header-content">
      <div class="header-boxes pl-4 pr-4">
        <v-row>
          <v-row align-content="center">
            <callout-button v-if="userDetails.Allows.AddCallouts"
                            class="mb-2 mr-4"></callout-button>
            <issue-button v-if="userDetails.Allows.AddIssues" class="mb-2 mr-4"></issue-button>
            <big-round-button v-if="userDetails.Allows.AllowPayments" class="mb-2 mr-4"
                              \color="success" icon="mdi-cash" to="financial/dept/payments"
                              text="Πληρωμή"></big-round-button>
            <big-round-button v-else-if="userDetails.Office.Email" color="secondary" class="mb-2 mr-4"
                              :href="'mailto:'+userDetails.Office.Email" icon="mdi-at" text="Email"></big-round-button>
          </v-row>
          <div v-if="userDetails.Allows.ShowDepts" style="min-width: 350px;">
            <dept-overview hide-title hide-details flat hide-buttons></dept-overview>
          </div>
        </v-row>
      </div>
    </portal>

    <div v-if=" (openIssuesLoading || calloutLoading) || (ongoingCallouts.length>0 || openIssues.length>0)"
         style="display: flex; gap:20px; justify-items: stretch; width: 100%;">
      <open-callouts class="mb-5" style="flex-grow: 1;"
                     v-if="(ongoingCallouts.length>0 && userDetails.Allows.ShowCallouts)||calloutLoading"
                     hide-buttons :loading="calloutLoading"/>
      <open-issues style="flex-grow: 1" v-if="(userDetails.Allows.AddIssues && openIssues.length>0)||openIssuesLoading"
                   hide-buttons
                   class="mb-5"
                   :loading="openIssuesLoading"/>
    </div>

    <div class="home-boxes">
      <div>
        <v-card class="mb-5 fill-height" style="min-width: 200px;"
                :loading="maintenancesLoading">
          <v-card-title> Tα
            <wnl-text> Ανυψωτικά </wnl-text> σας
          </v-card-title>
          <project-list max-height="48vh" ></project-list>
        </v-card>
        <!-- <v-card class="fill-height" style="min-width: 200px;">
          <v-card-title> Tα Κτήρια σας</v-card-title>
          <building-list max-height="48VH" class="mb-5"></building-list>
          <v-card-actions>
            <v-btn text color="primary" to="buildings">Όλα</v-btn>
          </v-card-actions>
        </v-card>
        -->
      </div>
      <div>
        <v-card flat class="fill-height">
          <v-card-title> Εργασίες</v-card-title>
          <recent-events max-height="48vh"></recent-events>
        </v-card>
        <!-- <maintenances list-max-height="33vh" class="mb-5" :loading="maintenancesLoading"/> -->
      </div>
      <div v-if="userDetails.Allows.ShowDepts">
        <dept-overview hide-header :loading="deptLoading"></dept-overview>
      </div>
    </div>

  </div>
</template>

<script>
import ProjectList from "@/views/Projects/components/ProjectList";
import CalloutButton from "@/views/Events/components/CalloutButton";
import IssueButton from "@/views/Issues/components/IssueButton";
import BigRoundButton from "@/components/BigRoundButton";
import DeptOverview from "@/views/Financial/components/DeptOverview";
import OpenCallouts from "@/views/Events/components/OpenCallouts";
import OpenIssues from "@/views/Events/components/OpenIssues";
import BuildingList from "@/views/Buildings/components/BuildingList";
import WnlText from "@/wl-unit-text/WnlText";
import RecentEvents from "@/views/Events/components/RecentEvents";
import homeMixin from "@/views/Dashboards/mixins/homeMixin";
// ... other imports ...

export default {
  name: "HomeDesktop",
  mixins: [homeMixin],
  components: {
    RecentEvents,
    WnlText,
    BuildingList,
    ProjectList,
    OpenIssues,
    OpenCallouts,
    DeptOverview,
    BigRoundButton,
    IssueButton,
    CalloutButton
    // Your components here
  }
}
</script>

<style scoped>
.home-boxes > * {
  min-width: 0%;
}

.header-boxes > * {
  min-width: 0%;
  align-self: center;
  align-items: center;
}

@media only screen and (min-width: 768px) and (max-width: 1200px) {
  .header-boxes {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 20px;
  }

  .home-boxes {
    display: grid;
    grid-gap: 20px;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
  }
}

@media only screen and (min-width: 1200px) {
  .header-boxes {
    display: flex;
    flex-wrap: nowrap;
    min-width: 25%;
    grid-gap: 20px;
  }

  .home-boxes {
    display: flex;
    flex-wrap: nowrap;
    grid-gap: 25px;
  }

  .home-boxes > * {
    flex-basis: 100%;
  }

  /* max width for the first home box */
  .home-boxes > *:first-child {
  }

  /* max width for the last home box */
  .home-boxes > *:last-child {

  }
}
</style>
